const CATALOG_URL =
  "https://delicices.com.br/catalogo/products.json";

async function getProducts() {
  const response = await fetch(CATALOG_URL);

  if (!response.ok) {
    throw new Error("Erro ao carregar catálogo.");
  }

  return response.json();
}

export { getProducts };